import { useEffect, useState } from 'react';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('tf_install_dismissed') === 'true');

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setDeferredPrompt(e); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!deferredPrompt || dismissed) return null;

  async function install() {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setDeferredPrompt(null);
  }

  function dismiss() {
    setDismissed(true);
    localStorage.setItem('tf_install_dismissed', 'true');
  }

  return (
    <div style={{
      position: 'fixed', bottom: 16, left: 16, right: 16, zIndex: 90,
      background: 'var(--bg-elev)', border: '1px solid var(--accent)', borderRadius: 'var(--radius-lg)',
      padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
      boxShadow: 'var(--shadow-md)',
    }}>
      <div>
        <div style={{ fontWeight: 600, fontSize: 14 }}>Install TrainForge</div>
        <div style={{ fontSize: 12, color: 'var(--text-dim)' }}>Add to home screen for the best experience</div>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button className="primary" onClick={install} style={{ padding: '8px 16px', minHeight: 0, fontSize: 12 }}>Install</button>
        <button onClick={dismiss} style={{ padding: '8px 12px', minHeight: 0, fontSize: 12 }}>Later</button>
      </div>
    </div>
  );
}
